import React, {Component} from 'react'
import { Button, Segment } from 'semantic-ui-react';

const successImage = require('./../assets/images/success.png');
const errorImage = require('./../assets/images/error.png');

export class Mensagem extends Component {

    render() {   

        const image = this.props.sucesso
        let { acao, sucesso} = this.props
       
        if(acao === "u"){
            if(sucesso === true){
                sucesso = <h3>Usuário Atualizado com sucesso!</h3>
            }else{
                sucesso = <h3>Ocorreu um erro, tente novamente!</h3> 

            }
        }else{
            if(sucesso === true){
                sucesso = <h3>Usuário cadastrado com sucesso!</h3>
            }else{
                sucesso = <h3>Ocorreu um erro, tente novamente!</h3> 

            }
        }

        const buttonStyle = {
            color: '#fff',
            backgroundColor: '#d60b52'
        }

        return (
            <Segment stacked>
                            
                <div className="field icones">
                    <div className="ui grid">
                        <div className="three column row">
                            <div className="column"></div>
                            <div className="column">
                                { image ? 
                                <div>
                                    <img alt="Sucesso" className="ui fluid image" src={successImage}/>
                                </div>
                                : 
                                <div>
                                    <img alt="Error" className="ui fluid image" src={errorImage}/>
                                </div>
                                }
                            </div>
                            <div className="column"></div>
                        </div>
                    </div>
                    <div>
                        { sucesso }
                    </div>
                </div>

                {sucesso ? 
                <Button 
                    style={buttonStyle} 
                    fluid 
                    size='large'
                    onClick={this.props.newPage}>
                    Novo Cadastro
                </Button>
                :
                <Button 
                    style={buttonStyle} 
                    fluid 
                    size='large'
                    onClick={this.props.defaultPage}>
                    Voltar
                </Button>                           
                
                }

            </Segment>
        )
    }
}


export default Mensagem;